import { StatusBottomBar, StatusContainerWithActionBar } from 'components/secondaryMarket/shared/status';
import { FC } from 'react';
import { useIntl } from 'react-intl';

type Props = Readonly<{ errorMessage: string }>;

export const QuoteErrorStatus: FC<Props> = ({ errorMessage }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <StatusContainerWithActionBar className="w-100 d-flex flex-column mb-0 alert alert-discreet-danger rounded-top-3">
        {formatMessage({
          id: `secondaryMarket.quotePanel.errors.errorMessages.${errorMessage}` as any,
          defaultMessage: errorMessage,
        })}
      </StatusContainerWithActionBar>
      <StatusBottomBar className="w-100 d-flex mb-0 alert alert-danger rounded-bottom-3">
        <div className="fw-bold">
          <em className="icon icon-sm">info_outline</em>
          <span className="ms-2" data-e2e="secondary-side-panel-status">
            {formatMessage({
              id: 'secondaryMarket.sidePanel.label.error',
            })}
          </span>
        </div>
      </StatusBottomBar>
    </>
  );
};
